<template>
	<span class="custom-control custom-checkbox">
			<input type="checkbox" class="custom-control-input" :id="id" @input="$emit('input',$event.target.checked)" @change="$emit('change')" :checked="value" :disabled="disabled">
			<label class="custom-control-label" :for="id"><b v-html="label"></b></label>
	</span>
</template>

<script>
	import { uuid } from '../../modules/helpers.js';
	export default {
			name: "CheckboxInline",
			props: ['label', 'value', 'disabled'],
			data: () =>  {
					return {
							id: uuid(),
					}
			},
	}
</script>

<style scoped>
	.custom-control {
		width: 100px;
		display: inline;
		margin-left: 5px;
		margin-right: 5px;
	}
</style>
